import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Language, LanguageList } from '../model/language.model';
import { Observable } from 'rxjs';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';

@Injectable()
export class LanguageService extends KiwixiService {
  apilanguages = environment.server + 'languages/';
  constructor(private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  getLanguages(filterParams): Promise<Language[]> {
    let params = new HttpParams();
    if (!!filterParams?.[Symbol.iterator]) {
      for (const filterParam of filterParams) {
        params = params.set(filterParam.key, filterParam.value);
      }
    }
    const headers = this.createHttpClientAuthorizationHeader();

    return this._http.get(this.apilanguages, { headers: headers, params: params })
      .toPromise()
      .then((res: any) => res)
      .catch(this.handleError);
  }

  getLanguage(id): Promise<Language> {
    const url = this.apilanguages + id;
    return this.getLanguageWithUrl(url);
  }

  getLanguageWithUrl(url): Promise<Language> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get(url, { headers: headers })
      .toPromise()
      .then((res: any) => res)
      .catch(this.handleError);
  }

  getObservableLanguageWithUrl(url): Observable<Language> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<Language>(url, { headers: header }).
      pipe(
        catchError(this.handleErrorObservable<Language>(`getLanguage`))
      );
  }

  getObservableLanguages(params?: HttpParams): Observable<LanguageList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<LanguageList>(this.apilanguages, {
      headers: header,
      params: params
    })
      .pipe(
        catchError(this.handleErrorObservable<LanguageList>(`getObservableLanguages`))
      );
  }

  getObservableLanguagesWithUrl(url: string): Observable<LanguageList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<LanguageList>(url, { headers: header })
      .pipe(
        catchError(this.handleErrorObservable<LanguageList>(`getObservableLanguagesWithUrl`))
      );
  }
}
